<template>

<core-modal v-on:close="onClose" icon="caret-left">

	<template v-slot:head>

		Edit Tag Family

	</template>

	<template v-slot:default>

		<core-form-input-textbox :autofocus="true" maxlength="16" name="text" v-on:validate="validate" placeholder="Enter name" v-model="inputs.name" notes="Maximum of 16 characters." :error="is.error" :disabled="is.loading" :validation="validation.name" />

		<core-form-input-togglelist title="Type" name="type" v-on:validate="validate" v-model="inputs.type" :error="is.error" :disabled="is.loading" :validation="validation.type" :options="typeOptions" />

		<core-form-input-togglelist title="Style" name="style" v-on:validate="validate" v-model="inputs.style" :error="is.error" :disabled="is.loading" :validation="validation.style" :options="styleOptions" />

		<core-form-input-colourpicker title="Background" name="colour" v-on:validate="validate" v-model="inputs.colour" :error="is.error" :disabled="is.loading" :validation="validation.colour" v-if="inputs.style" />

		<core-form-input-colourpicker title="Text" name="fore" v-on:validate="validate" v-model="inputs.fore" :error="is.error" :disabled="is.loading" :validation="validation.fore" :is-text="true" v-if="inputs.style" />

		<core-form-input-togglelist title="Seen by" name="public" v-on:validate="validate" v-model="inputs.public" :error="is.error" :disabled="is.loading" :validation="validation.public" :options="publicOptions" />

	</template>

	<template v-slot:foot>

		<core-button theme="blue" v-on:click.native="onConfirmClick" :loading="is.loading" :disabled="!inputs.name">Save changes</core-button>

		<core-button theme="red" v-on:click.native="onDeleteClick">Delete family</core-button>

	</template>

</core-modal>

</template>

<script>

import FormValidation from 'core/mixin/form/Validation.js'

export default {

	props: ['data'],
	
	mixins: [FormValidation],

	data: function() {

		return {

			is: {
				loading: false
			},

			inputs: {
				name: '',
                type: 0,
                style: 1,
				public: 1,
                colour: '#134677',
                fore: '#ffffff'
			},

			validation: {
				name: {
					exists: true,
					max: 16
				}
			}

		}

	},

	created: function() {

		this.inputs.name = this.family.name
		this.inputs.type = this.family.type
		this.inputs.style = this.family.style
		this.inputs.public = this.family.public
		this.inputs.colour = this.family.colour
		this.inputs.fore = this.family.fore

	},

	computed: {

		family: function() {

			return this.$store.getters['data/tagFamilies'][this.data.family]

		},

		typeOptions: function() {

			return [{
				value: 1,
				title: 'Exclusive',
				text: 'Only one tag from this tag family can be attached to an item.'
			}, {
				value: 0,
				title: 'Multiple',
				text: 'More than one tag from this tag family can be attached to an item.'
			}]

		},

		publicOptions: function() {

			return [{
				value: 1,
				title: 'Everyone',
				text: 'Anyone viewing your profile can see this tag family and filter with it.'
			}, {
				value: 0,
				title: 'Only me',
				text: 'Only you can see this tag family and filter with it.'
			}]

		},

		styleOptions: function() {

			return [{
				value: 1,
				title: 'Family style',
				text: 'Every tag in the family has the same colours.'
			}, {
				value: 0,
				title: 'Tag styles',
				text: 'Each tag in the family has its own colours.'
			}]

		}

	},

	methods: {

		onConfirmClick: function() {

			if (this.inputs.name) {

				this.is.loading = true

                this.$api.post('tags/family/update', {
                    family: this.data.family,
					data: this.inputs
				}).then(function(family) {

					this.$store.commit('data/tagFamilies/update', [family])

					var tags = this.$_.filter(this.$store.getters['data/tags/list'], function(tag) {

						return tag.family === this.data.family

					}.bind(this))

					this.$_.each(tags, function(tag) {

						tag.public = family.public

						if(family.style) {

							tag.fore = family.fore
							tag.colour = family.colour

						}

						this.$store.commit('data/tags/update', [tag])

					}.bind(this))

					this.onClose()

				}.bind(this), function() {

					this.is.error = true
					this.is.loading = false

				}.bind(this)) 

			}

		},

		onDeleteClick: function() {

			this.$pubsub.$emit('open.modal', {
				id: 'tagFamilyDelete',
				family: this.data.family
			})

		},

		onClose: function() {

			this.$emit('close')

			this.$pubsub.$emit('open.modal', {
                id: 'tagFamilyManage',
                family: this.data.family
            })

		}

	}

}

</script>

<style scoped>

</style>